module.exports = __webpack_public_path__ + "static/img/AboutWords.f3acab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/AboutWords.png
// module id = 206
// module chunks = 1